import { stETH } from '~/constants/tokens'
import { useTokenBalance } from '~/state/wallet/hooks'

export const useStEthBalance = () => {
  const stETHBalance = useTokenBalance(stETH)

  return stETHBalance
}
